import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import PopupWrapper from "../../components/PopupWrapper";

const SignatureField = ({ value, onChange, label }) => {
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const signatureRef = useRef(null);

  const saveSignature = (e) => {
    e.preventDefault();

    function validateStrokes() {
      const strokeData = signatureRef.current.toData();
      const minStrokeLength = 50; // Minimum stroke length (in pixels)

      let totalLength = 0;

      strokeData.forEach((stroke) => {
        let strokeLength = 0;
        for (let i = 1; i < stroke.length; i++) {
          const dx = stroke[i].x - stroke[i - 1].x;
          const dy = stroke[i].y - stroke[i - 1].y;
          strokeLength += Math.sqrt(dx * dx + dy * dy);
        }
        totalLength += strokeLength;
      });

      if (totalLength < minStrokeLength) {
        return false;
      } else {
        return true;
      }
    }

    if (signatureRef.current) {
      if (signatureRef.current.isEmpty()) {
        setShowAlert(true);
        return;
      }
      const isValid = validateStrokes();
      if (isValid) {
        const signature = signatureRef.current
          .getTrimmedCanvas()
          .toDataURL("image/png");
        onChange(signature);
        setShowSignaturePad(false);
      } else {
        setShowAlert(true);
      }
    }
  };

  const clearSignature = (e) => {
    e.preventDefault();
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  };

  return (
    <>
      <div className="form-group">
        <label className="form-label fw-bold small mb-2">{label}</label>
        <div
          className="border border-2 p-3"
          style={{
            minHeight: "100px",
            cursor: "pointer",
            backgroundColor: "#ffffff",
          }}
          onClick={() => setShowSignaturePad(true)}
        >
          {value ? (
            <img
              src={value}
              alt="Signature"
              style={{
                maxWidth: "100%",
                height: "80px",
                objectFit: "contain",
              }}
            />
          ) : (
            <div className="text-center text-muted py-3">
              <i className="bi bi-pencil-square me-2"></i>
              Click to sign
            </div>
          )}
        </div>
      </div>

      {/* Signature Pad Modal */}
      {showSignaturePad && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              height: "340px",
              backgroundColor: "white",
              padding: "20px",
              position: "relative",
              borderRadius: "8px",
            }}
          >
            <h5 className="mb-3">Sign Below</h5>
            <SignatureCanvas
              ref={signatureRef}
              penColor="black"
              canvasProps={{
                width: "760px",
                height: "260px",
                className: "sigCanvas border",
              }}
            />
            <button
              className="btn btn-primary"
              onClick={saveSignature}
              style={{
                position: "absolute",
                right: "20px",
                bottom: "20px",
              }}
            >
              Save
            </button>
            <button
              className="btn btn-secondary"
              onClick={clearSignature}
              style={{
                position: "absolute",
                left: "120px",
                bottom: "20px",
              }}
            >
              Clear
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => setShowSignaturePad(false)}
              style={{
                position: "absolute",
                left: "20px",
                bottom: "20px",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <CustomAlert showAlert={showAlert} setShowAlert={setShowAlert} />
    </>
  );
};

export default SignatureField;

export const CustomAlert = ({ showAlert, setShowAlert }) => {
  return (
    <PopupWrapper
      title=""
      extraClass="width-800"
      Component={
        <div>
          <p className="fw-bold text-center text-error">
            Please provide a valid signature before submitting.
          </p>
          <div className="d-flex justify-content-end gap-5 mb-3">
            <button
              className="btn btn-primary"
              onClick={() => setShowAlert(false)}
            >
              Ok
            </button>
          </div>
        </div>
      }
      toShow={showAlert}
      closeEventHandler={() => setShowAlert(false)}
    />
  );
};

